import { Image, StyleSheet } from 'react-native';
import { View } from '../Themed';
import useWindowDimensions from '../../hooks/useWindowDimensions';

// Image assets
import Img1 from '../../../assets/images/1.jpg';
import Img2 from '../../../assets/images/2.jpg';
import Img3 from '../../../assets/images/3.jpg';
import Img4 from '../../../assets/images/4.jpg';
import Img5 from '../../../assets/images/5.jpg';
import Img6 from '../../../assets/images/6.jpg';

const imageSize = { width: 200, height: 200 };

interface ImageColumnPropsType {
  images: any[];
  top: number;
}

function ImageColumn({ images, top }: ImageColumnPropsType): JSX.Element {
  return (
    <View style={[styles.imageCol, { top }]}>
      {images.map((el) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <View style={styles.imageContainer} key={`image_col_view_${el}`}>
            <Image source={el} style={{ ...imageSize }} />
          </View>
        );
      })}
    </View>
  );
}

export default function TiledImages() {
  const screenDimensions = useWindowDimensions();

  return (
    <View style={styles.container}>
      <ImageColumn images={[Img1, Img2]} top={70} />
      {screenDimensions.width > 400 && <ImageColumn images={[Img3, Img4]} top={-40} />}
      {screenDimensions.width > 800 && <ImageColumn images={[Img5, Img6]} top={70} />}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    alignSelf: 'center',
  },
  imageContainer: {
    backgroundColor: '#fff',
    shadowOpacity: 0.3,
    shadowRadius: 6,
    shadowOffset: {
      height: 3,
      width: 3,
    },
    margin: 30,
    padding: 10,
  },
  imageCol: {},
});
